/**
 * COVRFLY Cart Drawer v2.0
 * Maneja: abrir/cerrar, swipe-down, Esc, overlay,
 * AJAX add-to-cart, renderizar items, +/- cantidad, eliminar,
 * subtotal, estados del botón, interceptar header cart.
 */
(function () {
  'use strict';

  // ============================================================
  // REFERENCIAS DOM
  // ============================================================
  var drawer = document.getElementById('cf-cart-drawer');
  var overlay = document.getElementById('cf-cart-overlay');
  var closeBtn = drawer ? drawer.querySelector('.cf-drawer__close') : null;
  var dragHandle = drawer ? drawer.querySelector('.cf-drawer__drag-handle') : null;
  var drawerCount = document.getElementById('cf-drawer-count');
  var productsZone = document.getElementById('cf-drawer-products');
  var subtotalZone = document.getElementById('cf-drawer-subtotal');

  // Estado interno
  var isOpen = false;
  var touchStartY = 0;
  var touchCurrentY = 0;
  var isDragging = false;
  var isBusy = false; // Prevenir doble-click en acciones del carrito
  var _cfFetchToken = 0; // Token para descartar respuestas obsoletas

  // ============================================================
  // ABRIR / CERRAR DRAWER
  // ============================================================
  function open() {
    if (!drawer || !overlay || isOpen) return;
    isOpen = true;
    overlay.classList.add('is-visible');
    drawer.classList.add('is-open');
    document.body.classList.add('cf-drawer-open');
    drawer.setAttribute('tabindex', '-1');
    drawer.focus({ preventScroll: true });
    document.addEventListener('keydown', onKeyDown);
  }

  function close() {
    if (!drawer || !overlay || !isOpen) return;
    isOpen = false;
    overlay.classList.remove('is-visible');
    drawer.classList.remove('is-open');
    document.body.classList.remove('cf-drawer-open');
    drawer.style.transform = '';
    drawer.style.transition = '';
    document.removeEventListener('keydown', onKeyDown);
  }

  function onKeyDown(e) {
    if (e.key === 'Escape' || e.keyCode === 27) {
      close();
    }
  }

  // Click en overlay
  if (overlay) {
    overlay.addEventListener('click', close);
  }

  // Botón cerrar
  if (closeBtn) {
    closeBtn.addEventListener('click', close);
  }

  // ============================================================
  // SWIPE DOWN PARA CERRAR (mobile)
  // ============================================================
  if (drawer && dragHandle) {
    var swipeTargets = [dragHandle, drawer.querySelector('.cf-drawer__header')];
    swipeTargets.forEach(function (el) {
      if (!el) return;

      el.addEventListener('touchstart', function (e) {
        touchStartY = e.touches[0].clientY;
        touchCurrentY = touchStartY;
        isDragging = true;
        drawer.style.transition = 'none';
      }, { passive: true });

      el.addEventListener('touchmove', function (e) {
        if (!isDragging) return;
        touchCurrentY = e.touches[0].clientY;
        var diff = touchCurrentY - touchStartY;
        if (diff > 0) {
          drawer.style.transform = 'translateY(' + diff + 'px)';
        }
      }, { passive: true });

      el.addEventListener('touchend', function () {
        if (!isDragging) return;
        isDragging = false;
        var diff = touchCurrentY - touchStartY;
        if (diff > 100) {
          drawer.style.transition = 'transform 0.25s cubic-bezier(0.16, 1, 0.3, 1)';
          drawer.style.transform = 'translateY(100%)';
          setTimeout(close, 250);
        } else {
          drawer.style.transition = 'transform 0.25s cubic-bezier(0.16, 1, 0.3, 1)';
          drawer.style.transform = 'translateY(0)';
          setTimeout(function () {
            drawer.style.transition = '';
            drawer.style.transform = '';
          }, 250);
        }
      }, { passive: true });
    });
  }

  // ============================================================
  // UTILIDADES
  // ============================================================

  // Formatear precio (centavos → entero según modo)
  // FLOOR PRICING FIX (20-abr-2026, consenso cuarto IAs 4/4):
  // mode='item' cambió de ceil a floor → activa left-digit effect.
  // Con price points covrfly ($699/$799/$899) + tiers 15/20/25%,
  // floor produce terminaciones en 9 (charm natural). Caso estrella:
  // $799 × 25% = $599 (vs $600 anterior) → cruce barrera $600→$500.
  // Riesgo financiero CERO: Shopify checkout no compara per-item discounted.
  //
  // mode='item'      → Math.floor (charm natural, left-digit effect)
  // mode='subtotal'  → Math.ceil  (subtotal/total hacia arriba, cliente paga menos en checkout)
  // mode='savings'   → Math.floor (ahorro hacia abajo, no inflar percepción)
  // mode='marketing' → Math.floor (upsell left-digit neuromarketing, $599 zona 500)
  // mode undefined   → exacto (fallback legacy)
  function formatMoney(cents, mode) {
    var amount = cents / 100;
    var str;
    if (mode === 'item') {
      str = Math.floor(amount).toString();
    } else if (mode === 'subtotal') {
      str = Math.ceil(amount).toString();
    } else if (mode === 'savings' || mode === 'marketing') {
      str = Math.floor(amount).toString();
    } else {
      str = (cents % 100 === 0)
        ? Math.round(amount).toString()
        : amount.toFixed(2);
    }
    var parts = str.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return '$' + parts.join('.');
  }

  // URL de imagen optimizada (80x80)
  function imageUrl(src) {
    if (!src) return '';
    var base = src.split('?')[0];
    return base + '?width=144&height=144&crop=center';
  }

  // Extraer acabado de un variant title (default: "Glossy" si no tiene)
  function getVariantAcabado(variant) {
    if (!variant || !variant.title) return 'Glossy';
    var parts = (variant.title || '').split(' / ');
    if (parts.length < 2) return 'Glossy';
    var last = parts[parts.length - 1].trim();
    // Si el último segmento es Sí/Si/No, no es acabado → default Glossy
    if (/^(s[ií]|no)$/i.test(last)) return 'Glossy';
    return last;
  }

  // Inyectar CSS para chip de acabado y toggle (una sola vez)
  (function () {
    var style = document.createElement('style');
    style.textContent =
      '.cf-upsell-chip{position:absolute;bottom:8px;left:8px;padding:3px 8px;border-radius:6px;font-size:11px;font-weight:500;line-height:1.3;z-index:2;pointer-events:none;}' +
      '.cf-upsell-chip--glossy{background:rgba(255,255,255,0.85);-webkit-backdrop-filter:blur(8px);backdrop-filter:blur(8px);color:#525252;}' +
      '.cf-upsell-chip--matte{background:rgba(0,0,0,0.7);-webkit-backdrop-filter:blur(8px);backdrop-filter:blur(8px);color:#fff;}' +
      '.cf-upsell-acabado-toggle{display:flex;align-items:center;gap:8px;padding:6px 0 16px;}' +
      '.cf-upsell-acabado-label{font-size:12px;color:#888;white-space:nowrap;}' +
      '.cf-acabado-btn{font-size:12px;font-weight:500;padding:4px 12px;border-radius:20px;border:1px solid #ddd;background:#fff;color:#666;cursor:pointer;transition:all 0.2s ease;-webkit-tap-highlight-color:transparent;}' +
      '.cf-acabado-btn.is-active{background:#1a1a1a;color:#fff;border-color:#1a1a1a;}' +
      '.cf-upsell__title{text-align:center;}' +
      '.cf-upsell__price{text-align:center;display:flex;justify-content:center;align-items:center;gap:6px;flex-wrap:wrap;}' +
      '.cf-upsell__info{text-align:center;}' +
      '.cf-upsell__discount-badge{display:block;margin:4px auto 0;}';
    document.head.appendChild(style);
  })();

  // ============================================================
  // TOGGLE EMPTY STATE
  // ============================================================
  function toggleEmptyState(cart) {
    if (!drawer) return;
    if (cart.item_count === 0) {
      drawer.setAttribute('data-empty', 'true');
    } else {
      drawer.removeAttribute('data-empty');
    }
  }

  // ============================================================
  // ACTUALIZAR CONTEOS (drawer + header de la tienda)
  // ============================================================
  function updateCounts(count) {
    // Conteo en el drawer header
    if (drawerCount) {
      drawerCount.textContent = count;
    }
    // Burbuja del carrito en el header de la tienda
    var headerBubbles = document.querySelectorAll('#cart-notification-count');
    headerBubbles.forEach(function (el) {
      el.textContent = count;
    });
    // También actualizar cualquier otro indicador de carrito
    var bubbleContainers = document.querySelectorAll('.cart-count-bubble');
    bubbleContainers.forEach(function (el) {
      if (count > 0) {
        el.style.display = '';
      }
    });
  }

  // ============================================================
  // RENDERIZAR ITEMS DEL CARRITO
  // ============================================================
  function renderCart(cart) {
    if (!productsZone || !subtotalZone) return;

    // Tracking para detectar desbloqueo de envío gratis
    var prevItemCount = window._cfPrevItemCount || 0;
    var currentItemCount = cart.item_count;
    window._cfPrevItemCount = currentItemCount;

    toggleEmptyState(cart);
    updateCounts(cart.item_count);

    // Si está vacío, limpiar zonas y mostrar best sellers
    if (cart.item_count === 0) {
      productsZone.innerHTML = '';
      subtotalZone.innerHTML = '';
      var upsellZone = document.getElementById('cf-drawer-upsell');
      if (upsellZone) upsellZone.innerHTML = '';
      // Cargar productos del empty state si no se han cargado
      fetchEmptyProducts();
      // Notificar al upsell con datos del carrito ya actualizados
      document.dispatchEvent(new CustomEvent('covrfly:cart-updated', { detail: { cart: cart } }));
      return;
    }

    // Renderizar items
    var html = '';
    cart.items.forEach(function (item) {
      html += renderItem(item);
    });
    productsZone.innerHTML = html;

    // Carrusel upsell — solo re-fetch si los productos cambiaron
    var currentProductIds = cart.items.map(function (item) { return item.product_id; }).sort().join(',');
    var prevProductIds = window._cfPrevProductIds || '';

    if (cart.items.length > 0 && currentProductIds !== prevProductIds) {
      window._cfPrevProductIds = currentProductIds;
      fetchRecommendations(cart);
    } else if (cart.items.length > 0) {
      // Solo actualizar precios (el descuento puede cambiar con la cantidad)
      window._cfCurrentCart = cart;
      var upsellZone = document.getElementById('cf-drawer-upsell');
      if (upsellZone && window._cfUpsellProducts && window._cfUpsellProducts.length > 0) {
        var modelInfo = getCartModelInfo(cart);
        if (modelInfo) {
          try {
            var savedModel = sessionStorage.getItem('cf_upsell_model');
            if (savedModel) {
              var isSamsungSaved = /Galaxy|Samsung/i.test(savedModel);
              var isIphone11Saved = /iPhone\s*11/i.test(savedModel);
              modelInfo.modelName = savedModel;
              modelInfo.magsafeChoice = !(isSamsungSaved || isIphone11Saved) ? 'Si' : null;
              var savedAcabado = sessionStorage.getItem('cf_upsell_acabado');
              if (savedAcabado) modelInfo.acabado = savedAcabado;
            }
          } catch (e) {}

          var withVariant = [];
          window._cfUpsellProducts.forEach(function (p) {
            var match = findMatchingVariant(p, modelInfo);
            if (match && match.available !== false) {
              p._matchedVariant = match;
              withVariant.push(p);
            }
          });
          if (withVariant.length > 0) {
            renderUpsellCarousel(withVariant, modelInfo);
          }
        }
      }
    }

    // Renderizar subtotal + trust + CTA
    var footerHtml =
      '<div class="cf-subtotal-row">' +
        '<span class="cf-subtotal-label">Subtotal</span>' +
        '<span class="cf-subtotal-amount">' + formatMoney(cart.total_price, 'subtotal') + ' ' + (cart.currency || 'MXN') + '</span>' +
      '</div>';

    // Línea de ahorro como line item (solo si hay descuento)
    if (cart.total_discount && cart.total_discount > 0) {
      footerHtml +=
        '<div class="cf-savings-row">' +
          '<span class="cf-savings-label">Tu ahorro</span>' +
          '<span class="cf-savings-amount">-' + formatMoney(cart.total_discount, 'savings') + ' ' + (cart.currency || 'MXN') + '</span>' +
        '</div>';
    }

    // Línea de envío con anclaje de precio
    if (currentItemCount >= 2) {
      footerHtml +=
        '<div class="cf-footer__shipping">' +
          '<span class="cf-footer__shipping-label">Env\u00EDo</span>' +
          '<span class="cf-footer__shipping-value">' +
            '<span class="cf-footer__shipping-old">$129 MXN</span>' +
            '<span class="cf-footer__shipping-free">Sin costo</span>' +
          '</span>' +
        '</div>';
    } else if (currentItemCount === 1) {
      footerHtml +=
        '<div class="cf-footer__shipping">' +
          '<span class="cf-footer__shipping-label">Env\u00EDo estimado</span>' +
          '<span class="cf-footer__shipping-value cf-footer__shipping-paid">$129 MXN</span>' +
        '</div>';
    }

    subtotalZone.innerHTML = footerHtml;

    // Trust badges: métodos de pago (debajo del CTA)
    var trustZone = document.getElementById('cf-drawer-trust');
    if (trustZone) {
      trustZone.innerHTML =
        '<div class="cf-trust">' +
          '<img src="https://cdn.shopify.com/s/files/1/0741/3510/9868/files/VISAMASTERCADSHOPIFYPAYMENTS.svg?v=1783234277" ' +
            'alt="Pagos seguros: Visa, Mastercard, American Express, PayPal, Apple Pay, Google Pay y Shop Pay" ' +
            'class="cf-trust__icons" ' +
            'width="280" height="36" ' +
            'loading="lazy" ' +
            'draggable="false">' +
        '</div>';
    }

    // CTA Botón Ir a Pagar
    var ctaZone = document.getElementById('cf-drawer-cta');
    if (ctaZone) {
      ctaZone.innerHTML =
        '<a href="/checkout" class="cf-cta-checkout">Continuar al pago</a>';
    }

    // Pre-renderizar el shipping badge para evitar layout shift
    preRenderBadge(cart);

    // Notificar al upsell con datos del carrito ya actualizados
    document.dispatchEvent(new CustomEvent('covrfly:cart-updated', { detail: { cart: cart } }));

    // Reciprocidad: celebrar desbloqueo de env\u00EDo gratis
    var hadFreeShipping = prevItemCount >= 2;
    var hasFreeShipping = currentItemCount >= 2;
    if (!hadFreeShipping && hasFreeShipping) {
      setTimeout(function () {
        var shippingEl = null;
        var allEls = document.querySelectorAll('#covrfly-shipping-badge-drawer *');
        for (var i = 0; i < allEls.length; i++) {
          if (allEls[i].textContent.indexOf('Env') !== -1 && allEls[i].textContent.indexOf('sin costo') !== -1) {
            shippingEl = allEls[i];
            break;
          }
        }
        if (shippingEl) {
          shippingEl.classList.add('cf-shipping-unlocked');
          setTimeout(function () {
            shippingEl.classList.remove('cf-shipping-unlocked');
          }, 2000);
        }
      }, 300);
    }
  }

  // BUG 1 PATCH v2 — Parser _mczr_attributes (compatibilidad dual)
  // Kickflip cambió formato: keys embutidas en string JSON dentro
  // de properties._mczr_attributes. Este helper detecta el formato
  // y retorna un objeto plano con keys reales en AMBOS casos.
  function getKickflipProps(item) {
    if (!item || !item.properties) return {};
    var rawProps = item.properties;
    // ROBUSTO: NO retornar temprano por keys directas. Fusionar SIEMPRE
    // _mczr_attributes porque en el cart-item vivo el acabado/MagSafe pueden
    // venir SOLO dentro del blob aunque marca/modelo lleguen como keys directas.
    var flat = {};
    for (var k in rawProps) {
      if (Object.prototype.hasOwnProperty.call(rawProps, k)) {
        flat[k] = rawProps[k];
      }
    }
    if (typeof rawProps._mczr_attributes === 'string' && rawProps._mczr_attributes) {
      try {
        var attrs = JSON.parse(rawProps._mczr_attributes);
        if (Array.isArray(attrs)) {
          attrs.forEach(function (attr) {
            if (attr && typeof attr.key === 'string' && !(attr.key in flat)) {
              flat[attr.key] = attr.value;
            }
          });
        }
      } catch (e) {}
    }
    return flat;
  }

  function renderItem(item) {
    var img = item.image ? imageUrl(item.image) : '';
    var variantTitle = item.variant_title || '';

    // RONDA 3 — Detectar producto Kickflip (por presencia de _mczr_*)
    var isKickflip = false;
    if (item.properties) {
      var pKeys = Object.keys(item.properties);
      for (var ki = 0; ki < pKeys.length; ki++) {
        if (pKeys[ki].toLowerCase().indexOf('_mczr') !== -1) {
          isKickflip = true; break;
        }
      }
    }

    // BUG 1 PATCH v3 — Imagen Kickflip (B2 consenso 4/4)
    // Priorizar _mczr_image (diseño personalizado) sobre item.image
    // (funda blanca genérica). Solo para items Kickflip — catálogo
    // sigue usando imageUrl(item.image) sin cambios.
    if (isKickflip && item.properties && item.properties._mczr_image) {
      img = item.properties._mczr_image;
    }

    // BUG 1 PATCH v2 — Kickflip variant con parser _mczr_attributes
    // Usa getKickflipProps() para keys reales en AMBOS formatos
    if (isKickflip) {
      var kfProps = getKickflipProps(item);
      // A3: brand selector como ground truth
      var marcaKF = (kfProps['Selecciona tu marca'] || '').toString().toLowerCase();
      var modeloKF = '';
      if (marcaKF === 'apple') {
        modeloKF = kfProps['Apple'] || '';
      } else if (marcaKF === 'samsung') {
        modeloKF = kfProps['Samsung Galaxy'] || kfProps['Samsung'] || '';
      }
      // Fallback si marca desconocida
      if (!modeloKF) {
        modeloKF = kfProps['Apple'] || kfProps['Samsung Galaxy'] || kfProps['Samsung'] || '';
      }
      // Bomba 19: Samsung por marca directa
      var isSamsungKF = (marcaKF === 'samsung');
      var isIphone11KF = /iphone\s*11/i.test(modeloKF);
      // B4: MagSafe con regex combinada (actual + legacy)
      var magsafeKF = '';
      if (!isSamsungKF && !isIphone11KF) {
        var msProp = kfProps['Compatible con MagSafe'] || kfProps['MagSafe'] || '';
        if (/magsafe|^s[ií]$|^yes$/i.test(msProp)) { magsafeKF = 'MagSafe'; }
      }
      // C1: Acabado sin default Glossy (regla director)
      var acabadoKF = kfProps['Elige el acabado'] || kfProps['Acabado'] || kfProps['Finish'] || '';
      var partsKF = [];
      if (modeloKF) partsKF.push(modeloKF);
      if (magsafeKF) partsKF.push(magsafeKF);
      if (acabadoKF) partsKF.push(acabadoKF);
      variantTitle = partsKF.join(' - ');
      if (!modeloKF) { variantTitle = ''; }
    } else if (variantTitle) {
      // Traducir MagSafe según modelo (productos catálogo)
      var isSamsung = /Galaxy|Samsung/i.test(variantTitle);
      var isIphone11 = /iPhone\s*11/i.test(variantTitle);

      if (isSamsung || isIphone11) {
        variantTitle = variantTitle.replace(/\s*\/\s*S[ií]\b/i, '');
        variantTitle = variantTitle.replace(/\s*\/\s*No\b/i, '');
      } else {
        variantTitle = variantTitle.replace(/\s*\/\s*S[ií]\b/i, ' / MagSafe');
        variantTitle = variantTitle.replace(/\s*\/\s*No\b/i, '');
      }
      variantTitle = variantTitle.replace(/\s*\/\s*/g, ' - ');
      variantTitle = variantTitle.trim();
      if (!/glossy|matte/i.test(variantTitle) && variantTitle.length > 0) {
        variantTitle = variantTitle + ' - Glossy';
      }
    }

    // Usar line_price (ya multiplicado por qty) para transparencia total.
    // Antes usabamos original_price (unitario) + "× N" sufijo — cliente tenía
    // que multiplicar mental. Ahora mostramos el total de la linea directo.
    var hasDiscount = item.total_discount > 0;
    var lineOriginal = item.original_line_price;      // qty × original_price
    var lineFinal = item.original_line_price - item.total_discount; // cart-level discount fix
    var displayPrice = lineFinal;                     // precio final de la linea
    var unitDiscount = hasDiscount ? Math.round(item.total_discount / item.quantity) : 0;

    // BUG 1 PATCH v2 — D1 ajustado + parser compatible
    var EXCLUDED_PATTERNS = [
      'apple','samsung','magsafe','modelo','model',
      'acabado','finish','design','base','mask',
      'color','logo','selecciona','sube','galaxy'
    ];
    var propsHtml = '';
    // WHITELIST por tipo: items Kickflip NO muestran properties crudas (estado limpio pre-Matte). Catálogo sin cambios.
    var propsSource = isKickflip ? {} : (item.properties || {});
    var propsKeys = Object.keys(propsSource);
    propsKeys.forEach(function (key) {
      var val = propsSource[key];
      if (key.charAt(0) === '_' || !val) return;
      var keyLower = key.toLowerCase();
      var isExcluded = EXCLUDED_PATTERNS.some(function (pat) {
        return keyLower.indexOf(pat) !== -1;
      });
      if (isExcluded) return;
      if (typeof val === 'string' && val.indexOf('cdnv2.mycustomizer.com') !== -1) return;
      if (typeof val === 'string' && /^[a-f0-9]{24,}$/i.test(val)) return;
      propsHtml += '<span class="cf-cart-item__prop">' + escapeHtml(key) + ': ' + escapeHtml(val) + '</span>';
    });

    var priceHtml = '';
    var discountLabelHtml = '';
    if (hasDiscount) {
      var pctOff = Math.round((unitDiscount / item.original_price) * 100);
      priceHtml =
        '<span class="cf-cart-item__price-original">' + formatMoney(lineOriginal, 'item') + '</span>' +
        '<span class="cf-cart-item__price-final">' + formatMoney(lineFinal, 'item') + '</span>';

      // Pill de descuento inline: "-15%" al lado del precio
      if (pctOff > 0) {
        discountLabelHtml = '<span class="cf-discount-pill">-' + pctOff + '%</span>';
      }
    } else {
      priceHtml = '<span class="cf-cart-item__price-final">' + formatMoney(lineOriginal, 'item') + '</span>';
    }
    // BUG 1 FIX (20-abr-2026): Eliminado sufijo "× N". lineOriginal y lineFinal
    // ya son totales de la linea (qty multiplicado por Shopify). Transparencia total.

    return (
      '<div class="cf-cart-item" data-line-key="' + item.key + '">' +
        '<div class="cf-cart-item__image">' +
          (img ? '<img src="' + img + '" alt="' + escapeHtml(item.product_title) + '" width="72" height="72" loading="lazy">' : '') +
        '</div>' +
        '<div class="cf-cart-item__details">' +
          '<p class="cf-cart-item__title">' + escapeHtml(item.product_title) + '</p>' +
          (variantTitle ? '<p class="cf-cart-item__variant">' + escapeHtml(variantTitle) + '</p>' : '') +
          (propsHtml ? '<div class="cf-cart-item__properties">' + propsHtml + '</div>' : '') +
          '<div class="cf-cart-item__price">' + priceHtml + discountLabelHtml + '</div>' +
        '</div>' +
        '<div class="cf-cart-item__actions">' +
          '<div class="cf-cart-item__qty">' +
            '<button type="button" class="cf-qty-btn cf-qty-minus' + (item.quantity <= 1 ? ' is-disabled' : '') + '" data-key="' + item.key + '" aria-label="Reducir cantidad">&minus;</button>' +
            '<span class="cf-qty-value">' + item.quantity + '</span>' +
            '<button type="button" class="cf-qty-btn cf-qty-plus" data-key="' + item.key + '" aria-label="Aumentar cantidad">+</button>' +
          '</div>' +
          '<button type="button" class="cf-cart-item__remove" data-key="' + item.key + '" aria-label="Eliminar producto">' +
            '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2 4h12M5.333 4V2.667a1.333 1.333 0 011.334-1.334h2.666a1.333 1.333 0 011.334 1.334V4m2 0v9.333a1.333 1.333 0 01-1.334 1.334H4.667a1.333 1.333 0 01-1.334-1.334V4h9.334z" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
          '</button>' +
        '</div>' +
      '</div>'
    );
  }

  function escapeHtml(str) {
    if (!str) return '';
    return str.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  // ============================================================
  // SHIPPING BADGE: PRE-RENDER (misma lógica que covrfly-upsell.js)
  // Evita layout shift al pre-popular #covrfly-shipping-badge-drawer
  // ============================================================
  function calculateBadgeData(cart) {
    var count = 0;
    if (cart && cart.items) {
      cart.items.forEach(function (item) {
        if (item && item.product_type === 'Phone Case') {
          count += (item.quantity || 0);
        }
      });
    }
    // Fallback: si no hay product_type, usar item_count
    if (count === 0 && cart.item_count > 0) {
      count = cart.item_count;
    }

    var pill15 = '<span class="covrfly-pill">15% OFF</span>';
    var pill20 = '<span class="covrfly-pill">20% OFF</span>';
    var pill25 = '<span class="covrfly-pill">25% OFF</span>';
    var nextStep = '<span class="covrfly-next-step covrfly-pulse">Agrega 1 m\u00E1s</span>';

    var html = '';
    var pct = 0;

    if (count <= 1) {
      html =
        '<span class="covrfly-line primary">' + nextStep + ' para ' + pill15 + ' en tu pedido</span>' +
        '<span class="covrfly-line secondary"><span class="covrfly-accent-plus">+</span> Env\u00EDo sin costo</span>';
      pct = 25;
    } else if (count === 2) {
      html =
        '<span class="covrfly-line primary">Ya tienes ' + pill15 + ' en tu pedido</span>' +
        '<span class="covrfly-line secondary"><span class="covrfly-accent-plus">+</span> Env\u00EDo sin costo</span>' +
        '<span class="covrfly-line">' + nextStep + ' para ' + pill20 + '</span>';
      pct = 50;
    } else if (count === 3) {
      html =
        '<span class="covrfly-line primary">Ya tienes ' + pill20 + ' en tu pedido</span>' +
        '<span class="covrfly-line secondary"><span class="covrfly-accent-plus">+</span> Env\u00EDo sin costo</span>' +
        '<span class="covrfly-line">' + nextStep + ' para ' + pill25 + '</span>';
      pct = 75;
    } else {
      html =
        '<span class="covrfly-line primary">Ya tienes ' + pill25 + ' en tu pedido</span>' +
        '<span class="covrfly-line secondary"><span class="covrfly-accent-plus">+</span> Env\u00EDo sin costo</span>' +
        '<span class="covrfly-line primary"><span class="covrfly-standard-highlight">M\u00E1ximo descuento desbloqueado</span></span>';
      pct = 100;
    }

    return { html: html, pct: pct };
  }

  function preRenderBadge(cart) {
    var dc = document.getElementById('covrfly-shipping-badge-drawer');
    if (!dc) return;

    var data = calculateBadgeData(cart);

    // Crear o actualizar el <p> de texto
    var textEl = dc.querySelector('p.covrfly-shipping-text');
    if (!textEl) {
      textEl = document.createElement('p');
      textEl.className = 'covrfly-shipping-text';
      dc.prepend(textEl);
    }

    // Crear o actualizar el track de la barra
    var track = dc.querySelector('[data-covrfly-upsell="1"]');
    if (!track) {
      track = document.createElement('div');
      track.className = 'covrfly-upsell-track';
      track.setAttribute('data-covrfly-upsell', '1');
      track.innerHTML = '<div class="covrfly-upsell-fill"></div>';
      dc.appendChild(track);
    }

    var fill = track.firstElementChild;

    // Solo actualizar si el HTML cambió
    if (textEl.innerHTML !== data.html) {
      textEl.innerHTML = data.html;
    }
    fill.style.width = data.pct + '%';
  }

  // ============================================================
  // SHIPPING BADGE: AUTO-RESERVA DE ALTURA (anti layout shift)
  // Mide la altura real del badge y la guarda como min-height
  // para que re-renders posteriores no causen saltos.
  // Consenso: Claude + GPT + Gemini (17 Feb 2026)
  // ============================================================
  var _cfBadgeMaxH = 0;

  function measureAndReserveBadge() {
    var badge = document.getElementById('covrfly-shipping-badge-drawer');
    if (!badge || !badge.firstChild) return;

    var h = Math.ceil(badge.getBoundingClientRect().height);
    if (!h) return;

    // Guardar el máximo para que NUNCA se encoja
    if (h > _cfBadgeMaxH) {
      _cfBadgeMaxH = h;
    }

    var wrap = document.getElementById('cf-drawer-progress');
    if (wrap) {
      wrap.style.minHeight = _cfBadgeMaxH + 'px';
    }
  }

  // Medir después de cada actualización del carrito
  document.addEventListener('covrfly:cart-updated', function () {
    // 2 frames para esperar que covrfly-upsell.js renderice
    requestAnimationFrame(function () {
      requestAnimationFrame(measureAndReserveBadge);
    });
  });

  // ResizeObserver como blindaje extra contra re-renders internos
  if (window.ResizeObserver) {
    var badgeEl = document.getElementById('covrfly-shipping-badge-drawer');
    if (badgeEl) {
      var _cfBadgeRO = new ResizeObserver(function () {
        measureAndReserveBadge();
      });
      _cfBadgeRO.observe(badgeEl);
    }
  }

  // Primer intento inmediato
  setTimeout(measureAndReserveBadge, 0);

  // ============================================================
  // EMPTY STATE: Carruseles Favoritos + Nuevos
  // Reutiliza el mismo diseño del carrusel upsell
  // ============================================================
  var _cfEmptyLoaded = false;

  function fetchEmptyProducts() {
    if (_cfEmptyLoaded) return;

    // Fetch ambas colecciones en paralelo
    Promise.all([
      fetch('/collections/best-sellers/products.json?limit=12')
        .then(function (r) { return r.json(); })
        .catch(function () { return { products: [] }; }),
      fetch('/collections/new-drops/products.json?limit=12')
        .then(function (r) { return r.json(); })
        .catch(function () { return { products: [] }; })
    ]).then(function (results) {
      var favorites = (results[0] && results[0].products) ? results[0].products : [];
      var nuevos = (results[1] && results[1].products) ? results[1].products : [];

      _cfEmptyLoaded = true;

      // Renderizar carrusel Favoritos
      var favTrack = document.getElementById('cf-empty-fav-track');
      var favDots = document.getElementById('cf-empty-fav-dots');
      if (favTrack && favorites.length > 0) {
        renderEmptyCarousel(favorites, favTrack, favDots, '/collections/best-sellers');
      }

      // Renderizar carrusel Nuevos
      var newTrack = document.getElementById('cf-empty-new-track');
      var newDots = document.getElementById('cf-empty-new-dots');
      if (newTrack && nuevos.length > 0) {
        renderEmptyCarousel(nuevos, newTrack, newDots, '/collections/new-drops');
      } else {
        // Si no hay colección "nuevo", ocultar esa sección
        var newSection = document.getElementById('cf-empty-new');
        if (newSection) newSection.style.display = 'none';
      }
    }).catch(function (err) {
      console.error('[COVRFLY] Error empty state:', err);
    });
  }

  function renderEmptyCarousel(products, trackEl, dotsEl, collectionUrl) {
    var html = '';

    products.forEach(function (product) {
      // Primera variante disponible
      var variant = null;
      for (var i = 0; i < product.variants.length; i++) {
        if (product.variants[i].available !== false) {
          variant = product.variants[i];
          break;
        }
      }
      if (!variant) return;

      // Imagen
      var img = '';
      if (product.images && product.images.length > 0) {
        var imgSrc = typeof product.images[0] === 'string' ? product.images[0] : (product.images[0].src || '');
        img = imgSrc.split('?')[0] + '?width=280&height=280&crop=center';
      }

      // Precio: Product API devuelve string "799.00" o int centavos
      var price = variant.price;
      var priceCents = typeof price === 'string'
        ? Math.round(parseFloat(price) * 100)
        : (price > 10000 ? price : Math.round(price * 100));
      var priceDisplay = formatMoney(priceCents, 'marketing');

      // Card HTML — IDÉNTICO al upsell carousel
      html += '<a href="/products/' + product.handle + '" class="cf-upsell__card" tabindex="0">';
      html += '<div class="cf-upsell__card-inner">';
      html += '<div class="cf-upsell__image-wrap">';
      if (img) {
        html += '<img src="' + img + '" alt="' + escapeHtml(product.title) + '" loading="lazy">';
      }
      html += '</div>';
      html += '<div class="cf-upsell__info">';
      html += '<p class="cf-upsell__title">' + escapeHtml(product.title) + '</p>';
      html += '<p class="cf-upsell__price">' + priceDisplay + '</p>';
      html += '</div>';
      html += '</div>';
      html += '</a>';
    });

    // Card "Ver todos" al final del carrusel
    if (collectionUrl) {
      html += '<a href="' + collectionUrl + '" class="cf-upsell__card cf-upsell__card--more">';
      html += '<div class="cf-upsell__card-inner cf-upsell__card-inner--more">';
      html += '<div class="cf-upsell__more-circle">';
      html += '<span class="cf-upsell__more-arrow">\u2192</span>';
      html += '</div>';
      html += '<p class="cf-upsell__title cf-upsell__title--more">Ver todos</p>';
      html += '</div>';
      html += '</a>';
    }

    trackEl.innerHTML = html;

    // Dots de paginación
    var cards = trackEl.querySelectorAll('.cf-upsell__card');
    if (dotsEl && cards.length > 1) {
      var dotsHtml = '';
      for (var d = 0; d < cards.length; d++) {
        dotsHtml += '<span class="cf-upsell__dot' + (d === 0 ? ' is-active' : '') + '"></span>';
      }
      dotsEl.innerHTML = dotsHtml;

      // Scroll → actualizar dots
      var dots = dotsEl.querySelectorAll('.cf-upsell__dot');
      trackEl.addEventListener('scroll', function () {
        if (!cards.length) return;
        var scrollLeft = trackEl.scrollLeft;
        var cardWidth = cards[0].offsetWidth;
        var gap = 12;
        var activeIndex = Math.round(scrollLeft / (cardWidth + gap));
        if (activeIndex < 0) activeIndex = 0;
        if (activeIndex >= dots.length) activeIndex = dots.length - 1;
        for (var i = 0; i < dots.length; i++) {
          if (i === activeIndex) {
            dots[i].classList.add('is-active');
          } else {
            dots[i].classList.remove('is-active');
          }
        }
      }, { passive: true });
    }
  }

  // ============================================================
  // UPSELL: EXTRAER MODELO DEL CARRITO
  // ============================================================
  function getCartModelInfo(cart) {
    if (!cart.items || cart.items.length === 0) return null;
    var lastItem = cart.items[cart.items.length - 1];

    // ── KICKFLIP CARROUSEL FIX CAPA 1 (21-abr-2026) ──
    // Detectar producto Kickflip personalizado y extraer modelo de _mczr_attributes.
    // Sin esto, variant_title es vacío para Kickflip y el carrusel abortaba.
    var isKickflipItem = false;
    if (lastItem.properties) {
      var pKeysKf = Object.keys(lastItem.properties);
      for (var ki = 0; ki < pKeysKf.length; ki++) {
        if (pKeysKf[ki].toLowerCase().indexOf('_mczr') !== -1) {
          isKickflipItem = true; break;
        }
      }
    }
    if (isKickflipItem) {
      var kfP = getKickflipProps(lastItem);
      var marcaKf = (kfP['Selecciona tu marca'] || '').toLowerCase();
      var kfModelName = '';
      if (marcaKf === 'apple') {
        kfModelName = kfP['Apple'] || '';
      } else if (marcaKf === 'samsung') {
        kfModelName = kfP['Samsung Galaxy'] || kfP['Samsung'] || '';
      }
      if (!kfModelName) {
        kfModelName = kfP['Apple'] || kfP['Samsung Galaxy'] || kfP['Samsung'] || '';
      }
      if (kfModelName) {
        var isSamsungKf = (marcaKf === 'samsung');
        var isIphone11Kf = /iphone\s*11/i.test(kfModelName);
        var hasMagsafeKf = !(isSamsungKf || isIphone11Kf);
        var magsafeKf = hasMagsafeKf ? 'Si' : null;
        if (hasMagsafeKf) {
          var msKf = kfP['MagSafe'] || '';
          if (!/con\s*magsafe|^s[ií]$|^yes$/i.test(msKf)) magsafeKf = 'No';
        }
        var acabadoKf = (kfP['Acabado'] || kfP['Finish'] || '').toLowerCase() || null;
        return {
          modelName: kfModelName,
          magsafeChoice: magsafeKf,
          acabado: acabadoKf,
          productId: lastItem.product_id
        };
      }
    }
    // ── FIN KICKFLIP DETECTION ──

    var variantTitle = lastItem.variant_title || '';

    // variant_title: "iPhone 17 Pro Max / Sí / Matte Premium" o "Galaxy S25 Ultra / Glossy"
    var parts = variantTitle.split(' / ');
    var modelName = parts.length > 0 ? parts[0].trim() : '';
    var magsafeChoice = 'Si'; // default para iPhones
    var acabado = null;

    var isSamsung = /Galaxy|Samsung/i.test(modelName);
    var isIphone11 = /iPhone\s*11/i.test(modelName);
    var hasMagsafe = !(isSamsung || isIphone11);

    if (hasMagsafe && parts.length > 1) {
      // MagSafe SIEMPRE está en posición [1] para iPhones
      var msValue = parts[1].trim().toLowerCase();
      if (/^no$/i.test(msValue)) {
        magsafeChoice = 'No';
      }
    }

    // Acabado: posición [2] para iPhone (3 opciones), posición [1] para Samsung (2 opciones)
    if (hasMagsafe && parts.length >= 3) {
      acabado = parts[2].trim().toLowerCase();
    } else if (!hasMagsafe && parts.length >= 2) {
      acabado = parts[1].trim().toLowerCase();
    }

    return {
      modelName: modelName,
      magsafeChoice: hasMagsafe ? magsafeChoice : null,
      acabado: acabado,
      productId: lastItem.product_id
    };
  }

  // ============================================================
  // UPSELL: ENCONTRAR VARIANTE CORRECTA
  // ============================================================
  function findMatchingVariant(product, modelInfo) {
    if (!modelInfo || !modelInfo.modelName || !product.variants) return null;

    var normalizedModel = modelInfo.modelName.toLowerCase().replace(/\s+/g, ' ').trim();
    var bestMatch = null;
    var acabadoPreference = modelInfo.acabado || null;

    for (var i = 0; i < product.variants.length; i++) {
      var v = product.variants[i];
      if (v.available === false) continue;

      var vTitle = (v.title || '').toLowerCase().replace(/\s+/g, ' ').trim();
      var vParts = vTitle.split(' / ');
      var vModel = vParts[0].trim();

      if (vModel !== normalizedModel) continue;

      // Samsung/iPhone 11: no tienen MagSafe
      if (!modelInfo.magsafeChoice) {
        if (acabadoPreference && vParts.length >= 2) {
          if (vParts[vParts.length - 1].trim() === acabadoPreference) {
            bestMatch = v;
            break; // match perfecto: modelo + acabado
          }
          if (!bestMatch) bestMatch = v;
          continue;
        }
        bestMatch = v;
        break;
      }

      // iPhones 12+: MagSafe está en posición [1]
      var vMagsafe = vParts.length > 1 ? vParts[1].trim() : '';
      var wantsMagsafe = modelInfo.magsafeChoice.toLowerCase();
      var magsafeMatch = false;

      if (wantsMagsafe === 'si' && /^s[ií]$/i.test(vMagsafe)) magsafeMatch = true;
      if (wantsMagsafe === 'no' && /^no$/i.test(vMagsafe)) magsafeMatch = true;

      if (!magsafeMatch) {
        if (!bestMatch) bestMatch = v;
        continue;
      }

      // MagSafe matchea. Si hay preferencia de acabado, intentar matchear
      if (acabadoPreference && vParts.length >= 3) {
        var vAcabado = vParts[2].trim();
        if (vAcabado === acabadoPreference) {
          bestMatch = v;
          break; // match perfecto: modelo + magsafe + acabado
        }
        if (!bestMatch) bestMatch = v;
        continue;
      }

      bestMatch = v;
      break;
    }

    return bestMatch;
  }

  // ============================================================
  // UPSELL: FETCH RECOMENDACIONES
  // ============================================================
  function fetchRecommendations(cart) {
    window._cfCurrentCart = cart;
    var modelInfo = getCartModelInfo(cart);
    // ── KICKFLIP CARROUSEL FIX CAPA 2 (21-abr-2026) ──
    // Si no se detectó modelo (Kickflip edge case), usar default popular
    // en vez de abortar. El selector de modelos permite al usuario cambiar.
    if (!modelInfo || !modelInfo.modelName) {
      modelInfo = {
        modelName: 'iPhone 16 Pro Max',
        magsafeChoice: 'Si',
        acabado: null,
        productId: cart.items[0].product_id
      };
    }

    // Guardar modelInfo para que "Cambiar modelo" lo herede
    window._cfCurrentModelInfo = modelInfo;

    // Verificar si hay modelo guardado en sessionStorage
    try {
      var savedModel = sessionStorage.getItem('cf_upsell_model');
      if (savedModel) {
        var isSamsungSaved = /Galaxy|Samsung/i.test(savedModel);
        var isIphone11Saved = /iPhone\s*11/i.test(savedModel);
        var hasMagsafeSaved = !(isSamsungSaved || isIphone11Saved);
        modelInfo.modelName = savedModel;
        modelInfo.magsafeChoice = hasMagsafeSaved ? 'Si' : null;
        // Preservar acabado del carrito o de sessionStorage
        var savedAcabado = sessionStorage.getItem('cf_upsell_acabado');
        if (savedAcabado) modelInfo.acabado = savedAcabado;
      }
    } catch (e) {}

    var upsellZone = document.getElementById('cf-drawer-upsell');
    if (!upsellZone) return;

    // Token para descartar respuestas obsoletas
    _cfFetchToken++;
    var myToken = _cfFetchToken;

    // Skeleton loader: reservar espacio mientras carga
    if (!upsellZone.querySelector('.cf-upsell')) {
      upsellZone.innerHTML =
        '<div class="cf-upsell cf-upsell--skeleton">' +
          '<div class="cf-upsell__header">' +
            '<div class="cf-skeleton-line" style="width:140px;height:16px;margin-bottom:6px"></div>' +
            '<div class="cf-skeleton-line" style="width:200px;height:13px"></div>' +
          '</div>' +
          '<div class="cf-upsell__track" style="gap:12px">' +
            '<div class="cf-skeleton-card"></div>' +
            '<div class="cf-skeleton-card"></div>' +
            '<div class="cf-skeleton-card"></div>' +
            '<div class="cf-skeleton-card"></div>' +
          '</div>' +
        '</div>';
    }

    // IDs de productos ya en el carrito (para excluirlos)
    var cartProductIds = {};
    cart.items.forEach(function (item) {
      cartProductIds[item.product_id] = true;
    });

    // Usar prefetch si existe, sino hacer fetch normal
    var fetchPromise;
    if (window._cfPrefetchPromise) {
      fetchPromise = window._cfPrefetchPromise;
      window._cfPrefetchPromise = null;
    } else {
      fetchPromise = Promise.all([
        fetch('/recommendations/products.json?product_id=' + modelInfo.productId + '&limit=10&intent=related')
          .then(function (r) { return r.json(); })
          .catch(function () { return { products: [] }; }),
        fetch('/recommendations/products.json?product_id=' + modelInfo.productId + '&limit=10&intent=complementary')
          .then(function (r) { return r.json(); })
          .catch(function () { return { products: [] }; })
      ]);
    }

    fetchPromise
      .then(function (results) {
        // Descartar si hay un fetch m\u00E1s nuevo en vuelo
        if (myToken !== _cfFetchToken) return;

        var products = (results[0] && results[0].products) ? results[0].products : [];
        var extra = (results[1] && results[1].products) ? results[1].products : [];

        // Combinar sin duplicados
        var seenIds = {};
        products.forEach(function (p) { seenIds[p.id] = true; });
        extra.forEach(function (p) {
          if (!seenIds[p.id]) {
            products.push(p);
            seenIds[p.id] = true;
          }
        });

        if (products.length === 0) {
          upsellZone.innerHTML = '';
          return;
        }

        // Filtrar: excluir productos ya en carrito
        var filtered = products.filter(function (p) {
          return !cartProductIds[p.id];
        });

        // Cachear para selector de modelo
        window._cfUpsellProducts = filtered;
        window._cfUpsellProductId = modelInfo.productId;
        window._cfUpsellCartProductIds = cartProductIds;

        // Filtrar: solo productos con variante disponible
        var withVariant = [];
        filtered.forEach(function (p) {
          var match = findMatchingVariant(p, modelInfo);
          if (match && match.available !== false) {
            p._matchedVariant = match;
            withVariant.push(p);
          }
        });

        if (withVariant.length === 0) {
          upsellZone.innerHTML = '';
          return;
        }

        renderUpsellCarousel(withVariant, modelInfo);
      })
      .catch(function (err) {
        console.error('[COVRFLY] Error recomendaciones:', err);
        upsellZone.innerHTML = '';
      });
  }

  // ============================================================
  // UPSELL: RENDERIZAR CARRUSEL
  // ============================================================
  function renderUpsellCarousel(products, modelInfo) {
    var upsellZone = document.getElementById('cf-drawer-upsell');
    if (!upsellZone) return;

    var displayProducts = products.slice(0, 12);

    var html = '<div class="cf-upsell">';

    // Header
    html += '<div class="cf-upsell__header">';
    html += '<p class="cf-upsell__heading">Te puede gustar</p>';
    html += '<p class="cf-upsell__subheading">';
    html += 'Para: <strong>' + escapeHtml(modelInfo.modelName) + '</strong>';
    html += ' <button type="button" class="cf-upsell__change-model">Cambiar modelo \u2192</button>';
    html += '</p>';
    html += '</div>';

    // BUG 2 FIX (19-abr-2026) — Toggle de acabado dinámico por modelo del usuario
    // Consenso cuarto IAs 4/4 (91.5% confianza). 5º toque autorizado al drawer.
    // Solo mostrar toggle si el MODELO DEL USUARIO realmente tiene 2+ acabados.
    var acabadoOptions = {};
    var userModel = ((modelInfo && modelInfo.modelName) || '').toLowerCase().replace(/\s+/g, ' ').trim();
    displayProducts.forEach(function (p) {
      if (!p.variants || !userModel) return;
      p.variants.forEach(function (v) {
        var vParts = (v.title || '').split(' / ');
        var vModel = (vParts[0] || '').toLowerCase().replace(/\s+/g, ' ').trim();
        if (vModel !== userModel) return;
        var a = getVariantAcabado(v);
        if (a) acabadoOptions[a.toLowerCase()] = a;
      });
    });
    var acabadoCount = Object.keys(acabadoOptions).length;
    var showAcabadoUI = acabadoCount >= 2;

    if (showAcabadoUI) {
      var currentAcabado = (modelInfo.acabado || '').toLowerCase();
      html += '<div class="cf-upsell-acabado-toggle" id="cfAcabadoToggle">';
      html += '<span class="cf-upsell-acabado-label">Acabado:</span>';
      var optKeys = Object.keys(acabadoOptions);
      // Ordenar: Glossy primero, Matte segundo
      optKeys.sort(function (a, b) { return a === 'glossy' ? -1 : 1; });
      optKeys.forEach(function (key) {
        var isActive = key === currentAcabado ? ' is-active' : '';
        html += '<button type="button" class="cf-acabado-btn' + isActive + '" data-acabado="' + key + '">' + escapeHtml(acabadoOptions[key]) + '</button>';
      });
      html += '</div>';
    }

    // Track (carrusel horizontal)
    html += '<div class="cf-upsell__track">';

    // Calcular descuento para el siguiente item (anclaje de precio)
    var itemCount = 0;
    if (window._cfCurrentCart && window._cfCurrentCart.items) {
      window._cfCurrentCart.items.forEach(function (item) {
        itemCount += item.quantity;
      });
    }
    var nextDiscountPct = 0;
    if (itemCount === 1) nextDiscountPct = 15;
    else if (itemCount === 2) nextDiscountPct = 20;
    else if (itemCount >= 3) nextDiscountPct = 25;

    displayProducts.forEach(function (product) {
      var variant = product._matchedVariant;
      if (!variant) return;

      // Prioridad: imagen de la variante > imagen del producto > primera imagen
      var img = '';
      if (variant.featured_image) {
        if (typeof variant.featured_image === 'string') {
          img = variant.featured_image;
        } else if (variant.featured_image.src) {
          img = variant.featured_image.src;
        }
      }
      if (!img && product.featured_image) {
        img = typeof product.featured_image === 'string' ? product.featured_image : (product.featured_image.src || '');
      }
      if (!img && product.images && product.images.length > 0) {
        img = typeof product.images[0] === 'string' ? product.images[0] : (product.images[0].src || '');
      }
      if (img) {
        var imgBase = img.split('?')[0];
        img = imgBase + '?width=200&height=200&crop=center';
      }

      // Precio: Product API devuelve string "799.00" o int centavos
      var price = variant.price;
      var priceCents = typeof price === 'string'
        ? Math.round(parseFloat(price) * 100)
        : (price > 10000 ? price : Math.round(price * 100));
      var priceDisplay = formatMoney(priceCents, 'marketing');

      html += '<div class="cf-upsell__card" data-variant-id="' + variant.id + '" role="button" tabindex="0">';
      html += '<div class="cf-upsell__card-inner">';
      html += '<div class="cf-upsell__image-wrap">';
      html += '<img src="' + img + '" alt="' + escapeHtml(product.title) + '" loading="lazy">';
      html += '</div>';
      html += '<div class="cf-upsell__info">';
      html += '<p class="cf-upsell__title">' + escapeHtml(product.title) + '</p>';
      // Precio con anclaje
      var priceHtml = '';
      if (nextDiscountPct > 0) {
        var discountedCents = Math.round(priceCents * (1 - nextDiscountPct / 100));
        var discountedDisplay = formatMoney(discountedCents, 'marketing');
        priceHtml += '<p class="cf-upsell__price">';
        priceHtml += '<span class="cf-upsell__price-original">' + priceDisplay + '</span>';
        priceHtml += '<span class="cf-upsell__price-final">' + discountedDisplay + '</span>';
        priceHtml += '</p>';
        priceHtml += '<span class="cf-upsell__discount-badge">' + nextDiscountPct + '% OFF</span>';
      } else {
        priceHtml += '<p class="cf-upsell__price">' + priceDisplay + '</p>';
      }
      html += priceHtml;
      html += '</div>';
      html += '</div>';
      html += '</div>';
    });

    // Card "Ver todos" al final del carrusel
    html += '<a href="/collections/all-designs" class="cf-upsell__card cf-upsell__card--more">';
    html += '<div class="cf-upsell__card-inner cf-upsell__card-inner--more">';
    html += '<div class="cf-upsell__more-circle">';
    html += '<span class="cf-upsell__more-arrow">\u2192</span>';
    html += '</div>';
    html += '<p class="cf-upsell__title cf-upsell__title--more">Ver todos</p>';
    html += '</div>';
    html += '</a>';

    html += '</div>'; // track

    // Dots de paginaci\u00F3n
    var totalCards = displayProducts.length + 1; // +1 por "Ver todos"
    if (totalCards > 1) {
      html += '<div class="cf-upsell__dots" id="cf-upsell-dots">';
      for (var d = 0; d < totalCards; d++) {
        var dotActive = d === 0 ? ' is-active' : '';
        html += '<span class="cf-upsell__dot' + dotActive + '"></span>';
      }
      html += '</div>';
    }

    html += '</div>'; // cf-upsell

    upsellZone.innerHTML = html;

    // Agregar sheet de selector de modelo — estructura idéntica al PDP
    var sheetHtml = '';
    sheetHtml += '<div class="cf-model-sheet" id="cf-model-sheet">';
    sheetHtml += '<div class="cf-model-sheet__backdrop"></div>';

    // Panel — misma estructura que #covrfly-modal del PDP
    sheetHtml += '<div class="cf-model-sheet__panel">';

    // Handle — idéntico a .cf-handle del PDP
    sheetHtml += '<div class="cf-handle"><span></span></div>';

    // Título — idéntico a .cf-modal-title del PDP
    sheetHtml += '<div class="cf-modal-title">Modelo de dispositivo</div>';

    // Tabs — idénticas a .cf-tabs / .cf-tab del PDP
    var appleBrand = /Galaxy|Samsung/i.test(modelInfo.modelName) ? '' : ' is-active';
    var samsungBrand = appleBrand ? '' : ' is-active';
    sheetHtml += '<div class="cf-tabs">';
    sheetHtml += '<button type="button" class="cf-tab' + appleBrand + '" data-brand="apple">Apple</button>';
    sheetHtml += '<button type="button" class="cf-tab' + samsungBrand + '" data-brand="samsung">Samsung</button>';
    sheetHtml += '</div>';

    // Lista Apple — usa .cf-list y .cf-card del PDP
    sheetHtml += '<div class="cf-list" data-brand-list="apple"' + (samsungBrand ? ' style="display:none;"' : '') + '>';
    var appleModels = [
      'iPhone 18 Pro Max', 'iPhone 18 Pro',
      'iPhone 17 Pro Max', 'iPhone 17 Pro', 'iPhone 17 Air', 'iPhone 17',
      'iPhone 16 Pro Max', 'iPhone 16 Pro', 'iPhone 16 Plus', 'iPhone 16',
      'iPhone 15 Pro Max', 'iPhone 15 Pro', 'iPhone 15 Plus', 'iPhone 15',
      'iPhone 14 Pro Max', 'iPhone 14 Pro', 'iPhone 14 Plus', 'iPhone 14',
      'iPhone 13 Pro Max', 'iPhone 13 Pro', 'iPhone 13',
      'iPhone 12 Pro Max', 'iPhone 12 Pro', 'iPhone 12',
      'iPhone 11 Pro Max', 'iPhone 11 Pro'
    ];
    appleModels.forEach(function (m) {
      var isActive = m === modelInfo.modelName ? ' is-selected' : '';
      sheetHtml += '<button type="button" class="cf-card' + isActive + '" data-model="' + m + '">' + m + '</button>';
    });
    sheetHtml += '</div>';

    // Lista Samsung
    sheetHtml += '<div class="cf-list" data-brand-list="samsung"' + (appleBrand ? ' style="display:none;"' : '') + '>';
    var samsungModels = [
      'Galaxy S26 Ultra', 'Galaxy S26+', 'Galaxy S26',
      'Galaxy S25 Ultra', 'Galaxy S25+', 'Galaxy S25',
      'Galaxy S24 Ultra', 'Galaxy S24+', 'Galaxy S24',
      'Galaxy S23 Ultra', 'Galaxy S23+', 'Galaxy S23'
    ];
    samsungModels.forEach(function (m) {
      var isActive = m === modelInfo.modelName ? ' is-selected' : '';
      sheetHtml += '<button type="button" class="cf-card' + isActive + '" data-model="' + m + '">' + m + '</button>';
    });
    sheetHtml += '</div>';

    sheetHtml += '</div>'; // panel
    sheetHtml += '</div>'; // sheet

    // Insertar el sheet en <body> para escapar stacking context del drawer
    var existingSheet = document.getElementById('cf-model-sheet');
    if (existingSheet) existingSheet.remove();
    document.body.insertAdjacentHTML('beforeend', sheetHtml);

    // Dots: actualizar al scrollear
    var track = upsellZone.querySelector('.cf-upsell__track');
    var dots = upsellZone.querySelectorAll('.cf-upsell__dot');
    if (track && dots.length > 0) {
      var cards = track.querySelectorAll('.cf-upsell__card');

      track.addEventListener('scroll', function () {
        if (!cards.length) return;

        var scrollLeft = track.scrollLeft;
        var cardWidth = cards[0].offsetWidth;
        var gap = 12;
        var activeIndex = Math.round(scrollLeft / (cardWidth + gap));

        if (activeIndex < 0) activeIndex = 0;
        if (activeIndex >= dots.length) activeIndex = dots.length - 1;

        for (var i = 0; i < dots.length; i++) {
          if (i === activeIndex) {
            dots[i].classList.add('is-active');
          } else {
            dots[i].classList.remove('is-active');
          }
        }
      }, { passive: true });
    }

    // Marcar como ya animado para evitar re-animaci\u00F3n en futuros renders
    setTimeout(function () {
      var upsellContainer = upsellZone.querySelector('.cf-upsell');
      if (upsellContainer) {
        upsellContainer.classList.add('has-animated');
      }
    }, 300);
  }

  // ============================================================
  // AJAX: FETCH CARRITO
  // ============================================================
  function fetchCart() {
    var cartUrl = (window.routes && window.routes.cart_url) ? window.routes.cart_url + '.js' : '/cart.js';
    return fetch(cartUrl, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin'
    })
    .then(function (r) { return r.json(); });
  }

  // ============================================================
  // AJAX: AGREGAR AL CARRITO
  // ============================================================
  function addToCart(formData) {
    return fetch('/cart/add.js', {
      method: 'POST',
      body: formData
    })
    .then(function (r) {
      if (!r.ok) {
        return r.json().then(function (data) {
          throw data;
        });
      }
      return r.json();
    });
  }

  // ============================================================
  // AJAX: CAMBIAR CANTIDAD
  // ============================================================
  function changeQuantity(key, quantity) {
    var changeUrl = (window.routes && window.routes.cart_change_url) ? window.routes.cart_change_url + '.js' : '/cart/change.js';
    return fetch(changeUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: key, quantity: quantity }),
      credentials: 'same-origin'
    })
    .then(function (r) { return r.json(); });
  }

  // ============================================================
  // ESTADOS DEL BOTÓN ADD-TO-CART
  // ============================================================
  var BTN_ICON_CART = '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" style="margin-right:8px"><path d="M6.25 6.39167V5.58334C6.25 3.70834 7.75833 1.86667 9.63333 1.69167C11.8667 1.47501 13.75 3.23334 13.75 5.42501V6.57501" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/><path d="M7.49998 18.3333H12.5C15.85 18.3333 16.45 16.9917 16.625 15.3583L17.25 10.3583C17.475 8.32501 16.8916 6.66667 13.3333 6.66667H6.66664C3.10831 6.66667 2.52498 8.32501 2.74998 10.3583L3.37498 15.3583C3.54998 16.9917 4.14998 18.3333 7.49998 18.3333Z" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/><path d="M12.9129 10H12.9204" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M7.07872 10H7.0862" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var BTN_ICON_CHECK = '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" style="margin-right:8px"><path d="M4 10.5L8 14.5L16 5.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function setButtonState(btn, state) {
    if (!btn) return;
    var span = btn.querySelector('span');
    var svg = btn.querySelector('svg');

    switch (state) {
      case 'loading':
        btn.disabled = true;
        btn.classList.add('cf-btn-loading');
        btn.classList.remove('cf-btn-success', 'cf-btn-error');
        if (span) span.textContent = 'Agregando...';
        break;

      case 'success':
        btn.disabled = false;
        btn.classList.remove('cf-btn-loading', 'cf-btn-error');
        btn.classList.add('cf-btn-success');
        btn.style.backgroundColor = '#22C55E';
        if (svg) svg.outerHTML = BTN_ICON_CHECK;
        if (span) span.textContent = 'Agregado al Carrito';
        setTimeout(function () {
          resetButton(btn);
        }, 2000);
        break;

      case 'error':
        btn.disabled = false;
        btn.classList.remove('cf-btn-loading', 'cf-btn-success');
        btn.classList.add('cf-btn-error');
        btn.style.backgroundColor = '#EF4444';
        if (span) span.textContent = 'Error, intenta de nuevo';
        // Volver a estado normal después de 3 segundos
        setTimeout(function () {
          resetButton(btn);
        }, 3000);
        break;

      case 'soldout':
        btn.disabled = true;
        btn.classList.remove('cf-btn-loading', 'cf-btn-success');
        btn.classList.add('cf-btn-error');
        btn.style.backgroundColor = '#EF4444';
        if (span) span.textContent = 'Agotado';
        setTimeout(function () {
          resetButton(btn);
        }, 3000);
        break;
    }
  }

  function resetButton(btn) {
    if (!btn) return;
    btn.disabled = false;
    btn.classList.remove('cf-btn-loading', 'cf-btn-success', 'cf-btn-error');
    btn.style.backgroundColor = '#0470E3';
    // Restaurar icono de carrito
    var svg = btn.querySelector('svg');
    if (svg) svg.outerHTML = BTN_ICON_CART;
    var span = btn.querySelector('span');
    if (span) span.textContent = 'Agregar Al Carrito';
  }

  // ============================================================
  // INTERCEPTAR ADD-TO-CART v4 — Estrategia:
  // Interceptar submit con capture:true + stopImmediatePropagation
  // para anular el handler del tema. Hacer nuestro propio fetch
  // a /cart/add.js. Esto funciona en producción y en el preview
  // real de Shopify. El 401 era SOLO del proxy localhost.
  // ============================================================

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.getAttribute('data-type') !== 'add-to-cart-form') return;

    e.preventDefault();
    e.stopImmediatePropagation();

    if (isBusy) return;
    isBusy = true;

    var productFormEl = form.closest('product-form');
    var submitBtn = (productFormEl || form).querySelector('[type="submit"]');
    var formData = new FormData(form);

    // Estado loading
    setButtonState(submitBtn, 'loading');
    if (submitBtn) {
      submitBtn.setAttribute('disabled', true);
      submitBtn.classList.add('loading');
    }

    fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
      credentials: 'same-origin'
    })
    .then(function (r) {
      if (!r.ok) {
        return r.json().then(function (d) { throw d; });
      }
      return r.json();
    })
    .then(function (item) {
      console.log('[COVRFLY] \u2705 Producto agregado:', item.title);
      setButtonState(submitBtn, 'success');

      // Prefetch recomendaciones en background (empieza antes de abrir drawer)
      if (item && item.product_id) {
        window._cfPrefetchPromise = Promise.all([
          fetch('/recommendations/products.json?product_id=' + item.product_id + '&limit=10&intent=related')
            .then(function (r) { return r.json(); })
            .catch(function () { return { products: [] }; }),
          fetch('/recommendations/products.json?product_id=' + item.product_id + '&limit=10&intent=complementary')
            .then(function (r) { return r.json(); })
            .catch(function () { return { products: [] }; })
        ]);
      }

      return fetchCart();
    })
    .then(function (cart) {
      renderCart(cart);
      // Esperar un frame para que el DOM se estabilice antes de animar
      requestAnimationFrame(function () {
        open();
      });
    })
    .catch(function (err) {
      console.error('[COVRFLY] Error al agregar:', err);
      if (err && err.status === 422) {
        setButtonState(submitBtn, 'soldout');
      } else {
        setButtonState(submitBtn, 'error');
      }
    })
    .finally(function () {
      isBusy = false;
      if (submitBtn) {
        submitBtn.classList.remove('loading');
      }
    });
  }, true); // capture: true = se ejecuta ANTES que product-form.js

  console.log('[COVRFLY] Cart drawer AJAX v4 activo \u2705');

  // ============================================================
  // ACCIONES DEL CARRITO: +/- CANTIDAD Y ELIMINAR
  // ============================================================
  document.addEventListener('click', function (e) {
    var target = e.target.closest('.cf-qty-plus, .cf-qty-minus, .cf-cart-item__remove');
    if (!target) return;

    e.preventDefault();
    if (isBusy) return;
    isBusy = true;

    var key = target.getAttribute('data-key');
    if (!key) { isBusy = false; return; }

    var item = target.closest('.cf-cart-item');
    var qtyEl = item ? item.querySelector('.cf-qty-value') : null;
    var currentQty = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;
    var newQty;

    if (target.classList.contains('cf-qty-plus')) {
      newQty = currentQty + 1;
    } else if (target.classList.contains('cf-qty-minus')) {
      newQty = currentQty - 1;
      if (newQty < 1) { isBusy = false; return; }
    } else {
      // Eliminar
      newQty = 0;
    }

    // Feedback visual inmediato
    if (qtyEl && newQty > 0) {
      qtyEl.textContent = newQty;
    }
    if (newQty === 0 && item) {
      item.style.opacity = '0.5';
    }

    changeQuantity(key, newQty)
      .then(function (cart) {
        renderCart(cart);
      })
      .catch(function (err) {
        console.error('COVRFLY Cart Drawer: Error al cambiar cantidad', err);
        // Re-fetch para estado real
        return fetchCart().then(renderCart);
      })
      .finally(function () {
        isBusy = false;
      });
  });

  // ============================================================
  // UPSELL: CLICK EN CARD DEL CARRUSEL (toda la card agrega al carrito)
  // ============================================================
  document.addEventListener('click', function (e) {
    // GUARD FASE 2 (19-abr-2026): en /cart, cart-page.js maneja esto. Consistencia con L1736.
    if (window.location.pathname === '/cart') return;
    var card = e.target.closest('.cf-upsell__card[data-variant-id]');
    if (!card) return;

    // No interceptar si es el card "Ver todos"
    if (card.classList.contains('cf-upsell__card--more')) return;

    e.preventDefault();
    if (isBusy) return;
    isBusy = true;

    var variantId = card.getAttribute('data-variant-id');
    if (!variantId) { isBusy = false; return; }

    // Feedback visual: card con checkmark verde
    card.classList.add('is-adding');

    var formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', '1');

    fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
      credentials: 'same-origin'
    })
    .then(function (r) {
      if (!r.ok) throw new Error('Error al agregar');
      return r.json();
    })
    .then(function () {
      return fetchCart();
    })
    .then(function (cart) {
      renderCart(cart);
    })
    .catch(function (err) {
      console.error('[COVRFLY] Error upsell add:', err);
      card.classList.remove('is-adding');
    })
    .finally(function () {
      isBusy = false;
    });
  });

  // ============================================================
  // TOGGLE DE ACABADO — Cambiar acabado del carrusel upsell
  // ============================================================
  document.addEventListener('click', function (e) {
    // GUARD FASE 2 (19-abr-2026): en /cart, cart-page.js maneja esto. Consistencia con L1736.
    if (window.location.pathname === '/cart') return;
    var btn = e.target.closest('.cf-acabado-btn');
    if (!btn) return;

    var newAcabado = btn.getAttribute('data-acabado');
    if (!newAcabado) return;

    // Actualizar estado visual de los botones
    var toggle = btn.closest('.cf-upsell-acabado-toggle');
    if (toggle) {
      toggle.querySelectorAll('.cf-acabado-btn').forEach(function (b) {
        b.classList.remove('is-active');
      });
      btn.classList.add('is-active');
    }

    // Actualizar modelInfo global
    if (window._cfCurrentModelInfo) {
      window._cfCurrentModelInfo.acabado = newAcabado;
    }

    // Guardar en sessionStorage
    try { sessionStorage.setItem('cf_upsell_acabado', newAcabado); } catch (ex) {}

    // Re-filtrar y re-renderizar con el nuevo acabado
    if (window._cfUpsellProducts && window._cfUpsellProducts.length > 0 && window._cfCurrentModelInfo) {
      var mi = window._cfCurrentModelInfo;
      var withVariant = [];
      window._cfUpsellProducts.forEach(function (p) {
        var match = findMatchingVariant(p, mi);
        if (match && match.available !== false) {
          p._matchedVariant = match;
          withVariant.push(p);
        }
      });
      if (withVariant.length > 0) {
        renderUpsellCarousel(withVariant, mi);
      }
    }
  });

  // ============================================================
  // SELECTOR DE MODELO — Sheet superpuesto (clases PDP)
  // ============================================================
  document.addEventListener('click', function (e) {
    // GUARD FASE 2 (19-abr-2026): en /cart, cart-page.js maneja esto. Consistencia con L1736.
    if (window.location.pathname === '/cart') return;
    var sheet = document.getElementById('cf-model-sheet');

    // Abrir sheet
    if (e.target.closest('.cf-upsell__change-model')) {
      if (sheet) sheet.classList.add('is-open');
      return;
    }

    // Cerrar sheet (backdrop)
    if (e.target.closest('.cf-model-sheet__backdrop')) {
      if (sheet) sheet.classList.remove('is-open');
      return;
    }

    // Tabs Apple / Samsung — solo dentro del sheet
    var brandTab = e.target.closest('.cf-tab');
    if (brandTab && sheet && sheet.contains(brandTab)) {
      var brand = brandTab.getAttribute('data-brand');

      var allTabs = sheet.querySelectorAll('.cf-tab');
      allTabs.forEach(function (t) { t.classList.remove('is-active'); });
      brandTab.classList.add('is-active');

      var allLists = sheet.querySelectorAll('.cf-list');
      allLists.forEach(function (l) { l.style.display = 'none'; });
      var targetList = sheet.querySelector('[data-brand-list="' + brand + '"]');
      if (targetList) targetList.style.display = 'block';
      return;
    }

    // Seleccionar modelo — solo dentro del sheet
    var modelCard = e.target.closest('.cf-card');
    if (modelCard && sheet && sheet.contains(modelCard)) {
      var newModel = modelCard.getAttribute('data-model');
      if (!newModel) return;

      // Cerrar sheet
      sheet.classList.remove('is-open');

      // Guardar en sessionStorage
      try { sessionStorage.setItem('cf_upsell_model', newModel); } catch (e) {}

      // Determinar MagSafe
      var isSamsung = /Galaxy|Samsung/i.test(newModel);
      var isIphone11 = /iPhone\s*11/i.test(newModel);
      var hasMagsafe = !(isSamsung || isIphone11);

      var newModelInfo = {
        modelName: newModel,
        magsafeChoice: hasMagsafe
          ? (window._cfCurrentModelInfo ? window._cfCurrentModelInfo.magsafeChoice || 'Si' : 'Si')
          : null,
        acabado: window._cfCurrentModelInfo
          ? window._cfCurrentModelInfo.acabado || null : null,
        productId: window._cfUpsellProductId || 0
      };
      window._cfCurrentModelInfo = newModelInfo;

      // Re-filtrar productos cacheados
      if (window._cfUpsellProducts && window._cfUpsellProducts.length > 0) {
        var withVariant = [];
        window._cfUpsellProducts.forEach(function (p) {
          var match = findMatchingVariant(p, newModelInfo);
          if (match && match.available !== false) {
            p._matchedVariant = match;
            withVariant.push(p);
          }
        });

        if (withVariant.length > 0) {
          renderUpsellCarousel(withVariant, newModelInfo);
        } else {
          var upsellZone = document.getElementById('cf-drawer-upsell');
          if (upsellZone) {
            upsellZone.innerHTML =
              '<div class="cf-upsell">' +
                '<div class="cf-upsell__header">' +
                  '<p class="cf-upsell__heading">No hay dise\u00F1os disponibles</p>' +
                  '<p class="cf-upsell__subheading">para ' + newModel + '. ' +
                  '<a href="/collections/all-designs" style="color:#0470E3;text-decoration:none;font-weight:500;">Ver cat\u00E1logo completo \u2192</a></p>' +
                '</div>' +
              '</div>';
          }
        }
      }
      return;
    }
  });

  // ============================================================
  // INTERCEPTAR CLICK EN ÍCONO DE CARRITO DEL HEADER
  // ============================================================
  document.addEventListener('click', function (e) {
    // Buscar si el click fue en el ícono de carrito del header o dentro de él
    var cartLink = e.target.closest('a.header__actions_btn--cart, a[href="/cart"], a[href$="/cart"]');
    if (!cartLink) return;

    // No interceptar si está en la página de carrito
    if (window.location.pathname === '/cart') return;

    e.preventDefault();
    e.stopPropagation();

    // Si ya hay contenido pre-renderizado, abrir sin re-render
    var hasContent = productsZone && productsZone.children.length > 0;
    if (hasContent) {
      open();
      // Refresh DESPUÉS de que la animación termine (400ms > 350ms del slide-up)
      setTimeout(function () {
        fetchCart().then(function (cart) {
          // Solo re-render si el carrito realmente cambió
          var currentCount = parseInt(drawerCount ? drawerCount.textContent : '0', 10);
          if (cart.item_count !== currentCount) {
            renderCart(cart);
          }
        });
      }, 400);
    } else {
      fetchCart()
        .then(function (cart) {
          renderCart(cart);
          open();
        })
        .catch(function (err) {
          console.error('COVRFLY Cart Drawer: Error al abrir carrito', err);
          open();
        });
    }
  }, true);

  // ============================================================
  // CARGAR CARRITO INICIAL AL CARGAR LA PÁGINA
  // ============================================================
  // Fetch silencioso para tener el conteo correcto
  fetchCart()
    .then(function (cart) {
      toggleEmptyState(cart);
      updateCounts(cart.item_count);
      if (cart.item_count > 0) {
        // Pre-renderizar badge ANTES de renderCart para que el espacio ya esté ocupado
        preRenderBadge(cart);
        renderCart(cart);
      }
    })
    .catch(function () {
      // Silenciar errores del fetch inicial
    });

  // ============================================================
  // API PÚBLICA
  // ============================================================
  window.CfCartDrawer = {
    open: open,
    close: close,
    isOpen: function () { return isOpen; },
    refresh: function () {
      return fetchCart().then(function (cart) {
        renderCart(cart);
        return cart;
      });
    }
  };

})();


